// extracted by mini-css-extract-plugin
module.exports = {"container":"Container-module--container---o4A7","containerExtended":"Container-module--container--extended--2Wdv3"};